export default __webpack_public_path__ + "static/media/approved.c61c4610.gif";